export const sharedUniforms = `
  uniform vec2 focalLength;
  uniform vec2 principlePoint;
  uniform vec2 imageSize;
`;
